import React from "react";
import { formatMessage } from "lib/globalize-util";
import Button from "components/form/flat-button";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";
import { RETAILER_LINK, BRAND_LINK } from "constants/login";

interface INotACustomerProps {
    onCloseNotACustomer: () => void;
}

export const NotACustomer: React.FunctionComponent<INotACustomerProps> = ({ onCloseNotACustomer }) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                zIndex: 3,
                margin: "0 auto",
                width: "340px",
                padding: "0px",
                backgroundColor: "transparent",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
            },
            $(" p", {
                fontSize: "14px !important",
                paddingTop: "36px !important",
            }),
            $(" .bottomLinks", {
                paddingTop: "46px",
                fontSize: "14px",
            })
        );
    }, []);

    const handleRetailerLink = React.useCallback(() => {
        window.location.href = RETAILER_LINK;
    }, []);

    const handleBrandClick = React.useCallback(() => {
        window.location.href = BRAND_LINK;
    }, []);

    return (
        <div {...styles}>
            <h1>{formatMessage("Sign Up for Lightspeed NuORDER")}</h1>
            <p className="additionalInfo">
                {formatMessage(
                    "Shop products, place orders, and visualize assortments from thousands of brands—all in one place."
                )}
            </p>
            <Button
                data-test={DATATEST.LOGIN.RETAILER_SIGNUP}
                label={formatMessage("Sign up as a Retailer")}
                fullWidth={true}
                onClick={handleRetailerLink}
            />
            <p className="additionalInfo">
                {formatMessage(
                    "Reach new audiences, create immersive online selling experiences, and grow your business across multiple sales channels."
                )}
            </p>
            <Button
                data-test={DATATEST.LOGIN.BRAND_SIGNUP}
                label={formatMessage("Sign up as a Brand")}
                fullWidth={true}
                onClick={handleBrandClick}
            />
            <a className="bottomLinks" onClick={onCloseNotACustomer}>
                {formatMessage("Return to login")}
            </a>
        </div>
    );
};
